<template>
    <table class="table table table-style2 table-striped">
        <thead>
            <tr>
                <th>#</th>
                <th>{{ trans[locale].name }}</th>
            </tr>
        </thead>
        <tbody v-if="no_of_not_allow_remove_users > 0">
            <tr v-for="(user_item, key) in not_allow_remove_users">
                <td>{{ key + 1 }}</td>
                <td>{{ user_item.name }}</td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="2" class="text-center">{{ trans[locale].no_record }}</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
    import { helperCommon } from "../../mixins/helper.common";
    export default {
        mixins: [ helperCommon ],
        name: "NotAllowRemoveUserTable",
        data() {
            return Object.assign(
                {
                    trans: {
                        'zh-HK': {
                            'name': '名稱',
                            'no_record': '暫沒任何記錄',
                        },
                        'en': {
                            'name': 'name',
                            'no_record': 'No record at this moment',
                        },
                    },
                    not_allow_remove_users: null,
                    component_name: this.$options.name,
                },
                { locale: window.locale }
            );
        },
        props: {
            is_debug: {
                required: false,
                type: Boolean,
                default: false
            },
            init_not_allow_remove_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
        },
        beforeDestroy() {
            if (this.is_debug) this.debugMessage('*** BEFORE Destroy => [' + this.component_name + ']', 'warning');
            this.debug_info('warning');
            window.eventHub.$off('update-picker-table-not-allow-remove-users');
        },
        beforeMount() {
            window.eventHub.$off('update-picker-table-not-allow-remove-users');
        },
        mounted() {
            if (this.is_debug) this.debugMessage('*** MOUNTED => [' + this.component_name + '] => mounted');
            this.debug_info();

            if (_.isNull(this.init_not_allow_remove_users))
            {
                this.not_allow_remove_users = null;
            } else {
                this.not_allow_remove_users = _.sortBy(this.init_not_allow_remove_users, (user) => {
                    return user.name;
                });
            }

            window.eventHub.$on('update-picker-table-not-allow-remove-users', (not_allow_remove_users) => {
                if (_.isNull(this.init_not_allow_remove_users))
                {
                    this.not_allow_remove_users = null;
                } else {
                    this.not_allow_remove_users = _.sortBy(not_allow_remove_users, (user) => {
                        return user.name;
                    });
                }
            });
        },
        methods : {
            debug_info(color_type) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] : ignored users: ' + JSON.stringify(this.init_not_allow_remove_users), color_type);
            },
        },
        watch: {
            not_allow_remove_users() {
                window.eventHub.$emit('update-picker-ignored-users', this.not_allow_remove_users);
            }
        },
        computed: {
            no_of_not_allow_remove_users() {
                return _.size(this.not_allow_remove_users);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/NotAllowRemoveUserTable.vue